export default "__VITE_PUBLIC_ASSET__9fd3a1c7__"